export default __webpack_public_path__ + "/dist/images/login-to-alysei.4b0d3faad83d085c832006887a34e5ad.png";